export default function Footer() {
  return (
    <div className="bg-gray-700 text-white text-center p-4">
      <p>© 2024 Your Application Name. All rights reserved.</p>
    </div>
  );
}
